import { TokenListMetadata, LoopWindType } from "@bridgesplit/abf-sdk";
import { bsMath, formatUsd, formatTokenAmount } from "@bridgesplit/utils";
import { hideScrollbarSx } from "@bridgesplit/ui";

import { LoopDisplayType } from "../../common/loop";
import { LoopExecutionDetails } from "./types";

export const WIDE_ROW_STYLE = {
    whiteSpace: "nowrap",
    overflow: "auto",
    maxWidth: "300px",
    ...hideScrollbarSx
};

export const FORMAT_OPTIONS = { compactLargeNumbers: true, short: true };

export function formatExecutionLossValue({
    executionDetails,
    principalToken,
    collateralToken,
    principalUsdPrice,
    collateralUsdPrice,
    displayTokenType,
    displayType
}: {
    executionDetails: LoopExecutionDetails | undefined;
    principalToken: TokenListMetadata | undefined;
    collateralToken: TokenListMetadata | undefined;
    principalUsdPrice: number | undefined;
    collateralUsdPrice: number | undefined;
    displayTokenType: LoopWindType | undefined;
    displayType: LoopDisplayType;
}) {
    if (!executionDetails?.executionLossAmount) return "--";

    const tokenPrice = displayTokenType === LoopWindType.Principal ? principalUsdPrice : collateralUsdPrice;
    const token = displayTokenType === LoopWindType.Principal ? principalToken : collateralToken;

    return formatTokenValue(executionDetails.executionLossAmount, tokenPrice, token, displayType);
}

export function formatTokenValue(
    usdAmount: number,
    tokenPrice: number | undefined,
    token: TokenListMetadata | undefined,
    displayType?: LoopDisplayType
) {
    if (displayType === LoopDisplayType.UsdCostBasis) {
        return formatUsd(usdAmount);
    }

    return formatTokenAmount(bsMath.div(usdAmount, tokenPrice), {
        symbol: token?.symbol,
        ...FORMAT_OPTIONS
    });
}
